import React, { useState } from 'react';
// import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';

const NoteInfo = () => {

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Note d'Information</h5>
                    {/* <Document
                        file="assets/pdfs/Endette_Prefinance.pdf" onLoadSuccess={onDocumentLoadSuccess}>
                        <Page pageNumber={pageNumber} />
                    </Document>
                    <p>Page {pageNumber} of {numPages}</p> */}

                </div>
            </div>
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(NoteInfo, comparisonFn);
